import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import productSaga from 'pages/Product/saga';
import productReducer, { initialState as productInitialState } from 'pages/Product/reducer';
import { listOrderupdate, toggleDrawer } from './action';
import { UpdateTableConfig } from './UpdateTableConfig';
import AddOrderUpdateDrawer from 'components/AddOrderUpdateDrawer';
import orderReducer, { initialState as orderInitialState } from 'pages/Orders/reducer';
import orderSaga from 'pages/Orders/saga';
// import AddOrderCancelDrawer from 'components/AddCancelOrderDrawer';

function UpdateOrder() {
  useInjectReducer({ key: 'orderupdate', reducer });
  useInjectSaga({ key: 'orderupdate', saga });
  useInjectReducer({ key: 'product', reducer: productReducer });
  useInjectSaga({ key: 'product', saga: productSaga });
  useInjectReducer({ key: 'order', reducer: orderReducer });
  useInjectSaga({ key: 'order', saga: orderSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  // const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedOrderupdate, setselectedOrderupdate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const orderupdateState = useSelector((state) => state.orderupdate || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = UpdateTableConfig(
      handleSearch,
      handleReset,
      editUserOrderupdate,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listOrderupdate({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserOrderupdate = (orderupdate) => {
    setselectedOrderupdate(orderupdate);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listOrderupdate(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listOrderupdate({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listOrderupdate({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Update Order"
        extra={
          <AddOrderUpdateDrawer
            initialState={initialState}
            productInitialState={productInitialState}
            orderInitialState={orderInitialState}
            selectedOrderupdate={selectedOrderupdate}
            resetPagination={resetPagination}
            editUserOrderupdate={editUserOrderupdate}
            roleAddResponsibility={_.includes(authState.userResponsibilities, 'ADD_UPDATE_ORDER')}
          />
        }
      >
        <Table
          columns={columns}
          loading={orderupdateState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={orderupdateState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={orderupdateState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={orderupdateState.loading}
          onChange={onPageChange}
        />
      </Card>
    </>
  );
}

export default UpdateOrder;
